const getTimeFormat = (state) =>
  state.smartPageHeaderReducer?.participantTimeFormat;

const initialState = {};

export function timePickerReducer(state = initialState, action) {
  return state;
}

export const mapStateToProps = (state) => {
  return {
    timeFormat: getTimeFormat(state),
  };
};
